import {
  getFontCss,
  HoverableLinkSizes,
  styleConstants,
  Tag,
  TagScales,
  TagSizes,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import SvgOrganizationFilled from 'src/components/Svgs/SvgOrganizationFilled'
import TestId from 'src/components/TestId/TestId'
import UserAvatar from 'src/components/UserAvatar/UserAvatar'
import { AvatarSizes } from 'src/enums'
import Trns from 'src/localization/Trns'
import { UserListModel } from 'src/models/user.models'
import { peopleMembersDetailUrl } from 'src/navigation/urls'
import { selectUserIdFromState } from 'src/redux/selectors/auth.selectors'
import { selectUserListModelsFromState } from 'src/redux/selectors/data/users.selectors'
import { css } from 'styled-components'

interface UserAvatarOrganizationAndNameProps {
  user: UserListModel
}

const UserAvatarOrganizationAndName: React.FC<
  UserAvatarOrganizationAndNameProps
> = (props): React.ReactElement => {
  const userId = useSelector(selectUserIdFromState)
  const users = useSelector(selectUserListModelsFromState)
  const currentOrgId = userId !== undefined ? users[userId].organizationId : ''

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        flex-grow: 2;
        height: 60px;
      `}
    >
      {props.user !== undefined && (
        <UserAvatar user={props.user} size={AvatarSizes.Medium} />
      )}
      <div
        css={css`
          display: flex;
          flex-direction: column;
          margin-left: 10px;
          overflow: hidden;
        `}
      >
        {props.user.hasFullName && (
          <div
            css={css`
              display: flex;
            `}
          >
            <HoverableLink
              to={peopleMembersDetailUrl(props.user.id)}
              ariaLabelSource={props.user.truncatedFullNameOrEmail}
              size={HoverableLinkSizes.Large}
              underline
              css={css`
                margin-bottom: 2px;
                margin-right: 6px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              `}
            >
              {props.user.truncatedFullNameOrEmail}
            </HoverableLink>
            {props.user.id === userId && (
              <span
                css={css`
                  margin-right: 6px;
                `}
              >
                <Trns source={'(You)'} />
              </span>
            )}
            {!!props.user.orgRoleDisplayTagTitle &&
              props.user.organizationId === currentOrgId && (
                <Tag
                  size={TagSizes.Small}
                  text={<Trns source={props.user.orgRoleDisplayTagTitle} />}
                  icon={
                    props.user.hasOrgOwnerPermissions ? (
                      <SvgOrganizationFilled
                        style={TagScales.medium}
                        css={css`
                          margin-top: -1px;
                          margin-left: -2px;
                        `}
                      />
                    ) : undefined
                  }
                />
              )}
          </div>
        )}
        <TestId testId={'approverEmail'}>
          <span
            id={props.user.email}
            css={css`
              overflow: hidden;
              text-overflow: ellipsis;
              ${getFontCss(
                12,
                styleConstants.colors.gray_darkest,
                styleConstants.fontFamilies.regular,
              )}
            `}
          >
            {props.user.email}
          </span>
        </TestId>
      </div>
    </div>
  )
}

export default UserAvatarOrganizationAndName
